import { CSSProperties, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Complex, Field } from '../../types';

import T_SHIRT from '../../icons/images/tShirt.png';
import BALL from '../../icons/images/ball.png';
import COFFEE from '../../icons/images/cofee.png';
import DRESSING_ROOM from '../../icons/images/dressingRoom.png';
import HEATING from '../../icons/images/heating.png';
import PARKING from '../../icons/images/parking.png';
import TRIBUNES from '../../icons/images/tribune.png';
import LIGHTING from '../../icons/images/lighting.png';
import COVER from '../../icons/images/roof.png';
import SHOWER from '../../icons/images/shower.png';
import { COMMON_TRANSLATE_KEYS } from '../../constants/translate-keys';

type Props = {
  width: number;
  height: number;
  service: keyof Field | keyof Complex;
};

const ArenaServiceIcon = ({ width = 25, height = 25, service }: Props) => {
  const { t } = useTranslation();

  const { imgSrc, alt, tooltip, style } = useMemo<{
    imgSrc: string | undefined;
    alt: string | undefined;
    tooltip: string | undefined;
    style: CSSProperties;
  }>(() => {
    let imgSrc: string | undefined;
    let alt: string | undefined;
    let tooltip: string | undefined;
    let style: CSSProperties = {};

    switch (service) {
      case 'coffee':
        imgSrc = COFFEE;
        alt = 'coffee';
        tooltip = t(COMMON_TRANSLATE_KEYS.COFFEE_SHOP);
        break;
      case 'providesBalls':
        imgSrc = BALL;
        alt = 'ball';
        tooltip = t(COMMON_TRANSLATE_KEYS.PROVIDE_BALLS);
        break;
      case 'providesTShirts':
        imgSrc = T_SHIRT;
        alt = 't-shirt';
        tooltip = t(COMMON_TRANSLATE_KEYS.PROVIDE_T_SHIRTS);
        break;
      case 'dressing':
        imgSrc = DRESSING_ROOM;
        alt = 'dressing-room';
        tooltip = t(COMMON_TRANSLATE_KEYS.DRESSING_ROOM);
        style = { opacity: '80%' }
        break;
      case 'heating':
        imgSrc = HEATING;
        alt = 'heating';
        tooltip = t(COMMON_TRANSLATE_KEYS.HEATING);
        break;
      case 'parking':
        imgSrc = PARKING;
        alt = 'parking';
        tooltip = t(COMMON_TRANSLATE_KEYS.PARKING);
        break;
      case 'tribunes':
        imgSrc = TRIBUNES;
        alt = 'tribunes';
        tooltip = t(COMMON_TRANSLATE_KEYS.TRIBUNES);
        break;
      case 'lighting':
        imgSrc = LIGHTING;
        alt = 'lighting';
        tooltip = t(COMMON_TRANSLATE_KEYS.LIGHTING);
        break;
      case 'showers':
      case 'shower':
        imgSrc = SHOWER;
        alt = 'shower';
        tooltip = t(COMMON_TRANSLATE_KEYS.SHOWERS);
        break;
      case 'isCovered':
        imgSrc = COVER;
        alt = 'cover';
        tooltip = t(COMMON_TRANSLATE_KEYS.IS_IT_COVERED);
        break;
      default:
        imgSrc = undefined;
        alt = undefined;
        tooltip = undefined;
        break;
    }

    return { imgSrc, alt, tooltip, style };
  }, [service, t]);

  if (!imgSrc || !alt) return <></>;

  return (
    <>
      <img
        src={imgSrc}
        alt={alt}
        className={`w-[${width}px] h-[${height}px]`}
        style={{
          ...style,
          filter: 'invert(40%) sepia(100%) saturate(500%) hue-rotate(60deg)',
        }}
        data-tooltip-id="tooltip"
        data-tooltip-content={tooltip}
      />
    </>
  );
};

export default ArenaServiceIcon;
